import React from 'react';
// styles
import styled from 'styled-components';

const EditIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Edit"
    className={className}
    role="img"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0513 4.53333L19.4667 5.94933C20.1151 6.59978 20.1151 7.65222 19.4667 8.30267L18.5227 9.24867C18.3925 9.3788 18.1815 9.3788 18.0513 9.24867L14.7513 5.94933C14.6212 5.81917 14.6212 5.60817 14.7513 5.478L15.6967 4.53333C16.3473 3.88403 17.4007 3.88403 18.0513 4.53333ZM14.0447 6.65733C13.9823 6.59437 13.8973 6.55886 13.8087 6.55867C13.7201 6.55869 13.6352 6.59395 13.5727 6.65667L6.29134 13.94C6.16121 14.0702 6.16121 14.2812 6.29134 14.4113L9.59001 17.71C9.72018 17.8401 9.93118 17.8401 10.0613 17.71L17.3393 10.432C17.469 10.3019 17.469 10.0914 17.3393 9.96133L14.0447 6.65733ZM5.62001 15.2C5.53464 15.1149 5.40999 15.0825 5.29401 15.1153C5.17784 15.1479 5.08834 15.2407 5.06001 15.358L4.05601 19.5427C4.02907 19.6554 4.06264 19.7741 4.14468 19.856C4.22719 19.937 4.34539 19.9702 4.45801 19.944L8.63934 18.944C8.75675 18.9159 8.84979 18.8265 8.88257 18.7103C8.91535 18.5942 8.88275 18.4693 8.79734 18.384L5.62001 15.2Z"
      fill="#CCD6E0"
    />
  </svg>
);

export default styled(EditIcon)``;
